import config from './config'

export default {
    getResources: function(productId = null) {
        const params = {
            productId: productId
        }
        return axios.get(config.API_URL + '/resources/find', {
            params: params
        })
    }
}